import type { Ref } from 'react';
import { Anchor } from '@mantine/core';
import classes from './FormErrorsSummary.module.css';

/** Пункт сводки: готовый текст или текст со ссылкой к полю, которое нужно исправить. */
export type FormErrorItem = string | { readonly label: string; readonly onSelect: () => void };

interface FormErrorsSummaryProps {
  /** Заголовок сводки (напр. «Исправьте ошибки в форме»). */
  readonly title: string;
  /** Уже переведённые требования: чего не хватает для отправки. */
  readonly items: readonly FormErrorItem[];
  /** Чтобы после попытки отправки перевести фокус на сводку. */
  readonly ref?: Ref<HTMLDivElement>;
}

// Единая сводка ошибок формы («Бюллетень»): заголовок и список того, чего не хватает, с красной линией слева, без
// заливки и рамки — так же, как сообщение формы `FormMessage`. Пункт со ссылкой ведёт к своему полю. Пустой список —
// сводки нет. Сводку не объявляем программе чтения с экрана: она повторяла бы её при каждом изменении формы.
export default function FormErrorsSummary({ title, items, ref }: FormErrorsSummaryProps) {
  if (items.length === 0) {
    return null;
  }
  return (
    <div ref={ref} tabIndex={-1} className={classes.summary}>
      <p className={classes.title}>{title}</p>
      <ul className={classes.list}>
        {items.map((item) => {
          const label = typeof item === 'string' ? item : item.label;
          return (
            <li key={label}>
              {typeof item === 'string' ? (
                item
              ) : (
                <Anchor component="button" type="button" size="sm" c="loss.8" underline="always" onClick={item.onSelect}>
                  {item.label}
                </Anchor>
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
}
